/* IT HIPPIE — verrouillage "dur" du scroll sur iOS pendant le chargement du scroll infini.
   La section "Grille IT HIPPIE" pose déjà html{overflow:hidden} + la classe .is-loading sur
   .ith__sentinel pendant le chargement, mais Safari iOS ne respecte pas toujours overflow:hidden.
   Ici on bloque aussi les gestes tactiles (touchmove) tant que .is-loading est présent.
   Fichier inerte sur les pages sans la grille (querySelector ne trouve rien). */
(function () {
  function blockTouch(e) { e.preventDefault(); }

  function bind(sentinel) {
    if (sentinel.dataset.iosLockBound === '1') return;
    sentinel.dataset.iosLockBound = '1';

    var locked = false;
    function sync() {
      var loading = sentinel.classList.contains('is-loading');
      if (loading && !locked) {
        locked = true;
        document.addEventListener('touchmove', blockTouch, { passive: false });
      } else if (!loading && locked) {
        locked = false;
        document.removeEventListener('touchmove', blockTouch, { passive: false });
      }
    }

    new MutationObserver(sync).observe(sentinel, {
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  }

  function init() {
    var sentinels = document.querySelectorAll('.ith__sentinel');
    for (var i = 0; i < sentinels.length; i++) bind(sentinels[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
